// @flow

import { DialogContent } from '@mui/material';
import { useIntl } from 'react-intl';
import Dialog from '@mui/material/Dialog';
import type { TbCustomerDataItem } from 'insight/types/Farmer.types';
import DevicesDataGrid from 'insight/components/datagrid/farmer/DevicesDataGrid';
import Slide from '@mui/material/Slide';
import React, { useEffect, useState } from 'react';
import { getTbFarmerDevicesByTypeWithTelemetry } from 'insight/api/ThingsboardApiService';
import { useDispatch } from 'react-redux';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';

const Transition = React.forwardRef(function Transition(props: any, ref: any): React$Node {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  open: boolean,
  handleClose: Function,
  customer: TbCustomerDataItem,
  devicesToFetch: Array,
  tabSelected: string
};

const DevicesDialog = ({ open, handleClose, customer, devicesToFetch, tabSelected }: Props): React$Node => {
  const [items, setItems] = useState([]);
  const intl = useIntl();
  const dispatch = useDispatch();

  let customerId = customer?.customerDetails?.id?.id;
  const customerName = customer?.customerDetails?.name;
  const title = intl.formatMessage({ id: 'app.datagrid.devices.dialog.title' }, { name: customerName });

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = () => {
    getTbFarmerDevicesByTypeWithTelemetry(dispatch, devicesToFetch, customerId).then((response) => setItems(response));
  };

  return (
    <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
          <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <DevicesDataGrid items={items} tabSelected={tabSelected} fetchDevices={fetchDevices} />
      </DialogContent>
    </Dialog>
  );
};

export default DevicesDialog;
